module.exports = __webpack_public_path__ + "static/media/ordner.59c5891f.jpg";